import React from "react";

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { Tooltip } from "./Tooltip";
import { nFormatter } from "../../services";
import { TooltipContent } from "./TooltipContent";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  leftRightXAxis: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& > p": {
      fontSize: 12,
      fontWeight: "bold",
    },
  },
}));

export const CustomStackedAreaChart = ({
  data,
  areas,
  height,
  CustomTooltipContent,
  unit,
  onlyLeftRightXAxis,
  hideXAxis,
  hideYAxis,
  hideSumOnToolTip,
  yAxisDy,
  yAxisDx,
  yAxisWidth,
  xAxisPadding,
  filledArea,
}) => {
  const classes = useStyles();

  return (
    <>
      <ResponsiveContainer width="100%" height={height || 300}>
        <AreaChart data={data}>
          <XAxis dataKey="x" tickLine={true} interval={2} hide={hideXAxis} padding={xAxisPadding} />
          <YAxis
            hide={hideYAxis}
            tickLine={false}
            axisLine={false}
            dy={yAxisDy}
            dx={yAxisDx}
            width={yAxisWidth}
            tickFormatter={nFormatter}
            yAxisId={"right"}
            color={COLORS.purple}
          />
          <Tooltip
            chartData={data}
            content={
              CustomTooltipContent ? (
                <CustomTooltipContent />
              ) : (
                <TooltipContent hideSum={hideSumOnToolTip} showDots={"potential_power_rev"} />
              )
            }
          />
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          {areas.map((area, i) => (
            <>
              {area.key === filledArea ? (
                <>
                  <Area
                    type="monotone"
                    dataKey={area.key}
                    fill={area.fill}
                    stroke={area.stroke}
                    strokeWidth={2}
                    unit={unit}
                    stackId={i - 1}
                  />
                </>
              ) : area.onlyBorder === true ? (
                <>
                  <Area
                    type="linear"
                    dataKey={area.key}
                    strokeDasharray="5 5"
                    fill={"none"}
                    stroke={area.stroke}
                    stackId={i}
                  />
                </>
              ) : (
                <Area
                  type="linear"
                  dataKey={area.key}
                  stroke={area.stroke || area.fill}
                  fill="none"
                  strokeWidth={2}
                  unit={unit}
                  stackId={i}
                />
              )}
            </>
          ))}

          <YAxis
            hide={hideYAxis}
            axisLine={false}
            dy={yAxisDy}
            dx={yAxisDx}
            width={yAxisWidth}
            tickFormatter={nFormatter}
            tick={{
              fill: COLORS.purple,
            }}
            tickLine={false}
          />

          <YAxis
            dataKey={"rental_revenue"}
            yAxisId="right-axis"
            orientation="right"
            hide={hideYAxis}
            tickFormatter={nFormatter}
            dy={yAxisDy}
            dx={yAxisDx}
            width={yAxisWidth}
            axisLine={false}
            tick={{
              fill: COLORS.cian,
            }}
            tickLine={false}
          />
        </AreaChart>
      </ResponsiveContainer>

      {onlyLeftRightXAxis && (
        <Grid className={classes.leftRightXAxis} container justifyContent="space-between">
          <Typography>{data[0].x}</Typography>
          <Typography>{data[data.length - 1].x}</Typography>
        </Grid>
      )}
    </>
  );
};

CustomStackedAreaChart.defaultProps = {
  hideYAxis: false,
  hideXAxis: false,
  yAxisDx: 0,
  yAxisDy: 0,
  yAxisWidth: 30,
  xAxisPadding: {},
};
